import React, { useEffect, useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";

import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import ComponentContainer from "../../layouts/component-container";

import { useDevice } from "../../utils/react-utils";
import { getCookie, trim } from "../../utils/utils";
import { getCreStories } from "../../helper/api";

import "./fourStoryCards.m.css";

const FourStoryCards = ({ collection, lang = "bn", domainSlug, member }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const {
    number_of_stories_skip_to_show: numberOfStoriesSkipToShow = 0,
    number_of_stories_to_show: storiesToLoad = 4,
    api_url: creApi,
    theme,
    show_sub_headline: showSubHeading = true,
  } = collection["associated-metadata"] || {};

  const stories = collection.items
    .filter(({ type, story }) => type === "story" && story)
    .splice(numberOfStoriesSkipToShow, storiesToLoad - numberOfStoriesSkipToShow);

  const [recommendedStories, setRecommendedStories] = useState(stories);
  const [loading, setLoading] = useState(false);
  const { mobile } = useDevice(false);

  const [mainCollection, setMainCollection] = useState(collection);

  useEffect(() => {
    const userId = getCookie("userID");

    if (userId && creApi && lang === "bn" && !domainSlug) {
      setLoading(true);
      getCreStories(creApi, userId)
        .then(({ data: { items = [] } = {} }) => {
          if (items.length > 0) {
            const creCollection = {
              ...collection,
              "associated-metadata": {
                navigate_to: "for-you",
                navigate_to_title: "আপনার জন্য",
                number_of_stories_to_show: 4,
                show_collection_name_mobile: true,
                show_collection_name_website: true,
              },
            };

            setMainCollection(creCollection);
            setRecommendedStories(items.slice(0, 4));
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  }, [member]);

  if (!recommendedStories.length) return null;

  return (
    <ComponentContainer
      collection={mainCollection}
      styleName={`four-story-4s ${loading ? "loading" : ""} `}
      className={trim(theme, "default")}
      isDesktopBanner={true}
      isBanner={true}
    >
      <div styleName={`story-container ${recommendedStories.length > 4 ? "double-row" : ""}`}>
        {recommendedStories.map(({ story }, index) => (
          <div styleName="story-card" key={index}>
            <LeftImageRightNews
              story={story}
              imageType={mobile && index > 0 ? "image1x1" : "image3x2"}
              aspectRatio={mobile && index > 0 ? [1, 1] : [3, 2]}
              showExcerpt={mobile ? index === 0 : true}
              widths={[350, 190, 320]}
              showSubHeading={showSubHeading}
            />
          </div>
        ))}
      </div>
    </ComponentContainer>
  );
};

FourStoryCards.propTypes = {
  collection: object,
  lang: string,
  domainSlug: string,
  member: object,
};

FourStoryCards.storyLimit = 12;

const mapStateToProps = (state) => ({
  lang: state.qt.config["publisher-attributes"].lang,
  domainSlug: state.qt.config.domainSlug,
  member: state.member,
});

export default connect(mapStateToProps)(FourStoryCards);
